package top.wcpe.allincore.ui.runtime.event

import kotlin.math.abs

/**
 * 鼠标滚轮事件。
 *
 * 注意：MC 1.20.1 平台只暴露单轴滚动量，故 [scrollX] 在该平台恒为 0；1.21.1+ 平台才同时提供水平/垂直滚动量。
 *
 * Phase 4 嵌套滚动协议：事件携带「已消费量」可变状态。子滚动容器先按 [remainingY] 滚动并 [consume] 自己实际
 * 消费的量；[InputDispatcher] 在 [fullyConsumed] 为 false 时把事件继续向父冒泡，实现「子到边界后父接管」。
 *
 * 历史上 ScrollEvent 是 record；为承载可变 consumed 状态改为普通类，保留同名方法式访问器
 * `mouseX()/mouseY()/scrollX()/scrollY()` 与 4 参构造，对既有调用方源码兼容。
 */
class ScrollEvent(mouseX: Double, mouseY: Double, scrollX: Double, scrollY: Double) {

    private val mouseX: Double = mouseX
    private val mouseY: Double = mouseY
    private val scrollX: Double = scrollX
    private val scrollY: Double = scrollY

    // 已被消费的滚动量（单位与 scrollX/Y 一致，即「行/格」）
    private var consumedX: Double = 0.0
    private var consumedY: Double = 0.0

    fun mouseX(): Double = mouseX

    fun mouseY(): Double = mouseY

    fun scrollX(): Double = scrollX

    fun scrollY(): Double = scrollY

    // -------- 嵌套滚动：已消费量 --------

    /** 累加已消费的滚动量。 */
    fun consume(dx: Double, dy: Double) {
        consumedX += dx
        consumedY += dy
    }

    fun consumedX(): Double = consumedX

    fun consumedY(): Double = consumedY

    /** 尚未被消费的水平滚动量。 */
    fun remainingX(): Double = scrollX - consumedX

    /** 尚未被消费的垂直滚动量。 */
    fun remainingY(): Double = scrollY - consumedY

    /** 两轴均已被完全消费（无剩余量需要冒泡）。 */
    fun fullyConsumed(): Boolean = abs(consumedX) >= abs(scrollX) && abs(consumedY) >= abs(scrollY)
}
